<section *ngIf="!isLoading"
         class="flex align-items-center justify-content-center">
  <div *ngIf="!showWeatherIcon"
       class="fadein animation-duration-1000"
       [innerHTML]="weatherIcon">
  </div>
  
  <div *ngIf="showWeatherIcon"
       class="fadein animation-duration-1000">
    {{ timeTempString }}
  </div>
</section>

<section *ngIf="isLoading"
         class="bg-black-alpha-20 flex justify-content-center align-items-center">
  <i class="bi bi-arrow-clockwise ci-txt--white ci-rotate"></i>
</section>